import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel, ApiResponseModel, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';
import { GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { Optional } from 'typescript-optional';
@Injectable({
  providedIn: 'root'
})
export class InternalPurchaseRefundNoteService extends BaseApiTemplateService<GenericDocContainerModel> {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-purchase-refund-notes';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-purchase-refund-notes';
    this.httpClient = http;
  }

  getReceiptsVouchersByLogin(pagination: Pagination, visa: ApiVisa){
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/login-entity-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  getLinesByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    customParam: Optional<string>,
    apiVisa: ApiVisa
  ): Observable<Blob> {
    let params;
    let url;
    if (customParam.isPresent()) {
        params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid)
        .set('customParam', customParam.get());
    } else {
        params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid);
    }
    url = apiVisa.api_domain_url + this.endpoint_path + '/print-jasper-pdf/' + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  discardGenericDocument(apiVisa: ApiVisa, guid: string) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<ApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + '/discard/backoffice-ep/' + guid,
      null, //empty body
      this.getHttpHeader(apiVisa)
    );
  }

  voidGenericDocument(dtoObject: Object, apiVisa: ApiVisa, guid: string) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<ApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + "/backoffice-ep/void/" + guid,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }

  createTemp(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + '/temp/backoffice-ep',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
